var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxCheck = function SvgCheckboxCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.131 1.693A.692.692 0 0 0 10.1.769L6.99 4.243c-.63.704-1.055 1.175-1.418 1.48-.345.29-.548.354-.726.354s-.38-.063-.726-.354c-.363-.305-.787-.776-1.417-1.48L1.9 3.347A.692.692 0 0 0 .87 4.27l.836.935c.587.655 1.077 1.202 1.524 1.578.474.398.984.679 1.617.679.634 0 1.144-.281 1.617-.679.447-.376.937-.923 1.524-1.578z",
    clipRule: "evenodd"
  })));
};
export { SvgCheckboxCheck as ReactComponent };